<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="overflow-fix" data-cy="admin-asi-suppliers-page">
    <h1>ASI Suppliers</h1>

    <top-table :columns="columns" url="/ps-api" :requestFunction="requestFunction" :overlap="true">
      <template v-slot:Info="props">
        <AddressFormat :address="props.row.Address" />
        <template v-for="(v, k) in props.row.Phone" v-if="k !== '$index'">
          <span>{{ k }}: {{ v }}</span> <br />
        </template>
        <span>{{ props.row.Email }}</span>
      </template>
      <template v-slot:Websites="props">
        <p v-for="i in props.row.Websites">{{ i }}</p>
      </template>
    </top-table>
  </div>
</template>

<script>
import AddressFormat from '../../../components/AddressFormat';
export default {
  name: 'AdminAsiSuppliers',
  components: { AddressFormat },
  data() {
    return {
      columns: ['Id', 'Name', 'AsiNumber', 'Info', 'Websites', 'Products']
    };
  },
  methods: {
    requestFunction(p) {
      p.url = '/distributor_portal/asi/suppliers';
    }
  }
};
</script>
